<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { TextAndImageRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: TextAndImageRecord }>();
</script>

<template>
  <div class="gap-xl grid grid-cols-1 md:grid-cols-2">
    <div :class="{ 'order-1 md:order-1': data.imagePosition, 'order-1 md:order-2': !data.imagePosition }">
      <DatocmsImage v-if="data.image" :data="data.image.responsiveImage as ResponsiveImageType" class="rounded-sm" />
    </div>
    <div :class="{ 'order-2 md:order-1': !data.imagePosition, 'order-2 md:order-2': data.imagePosition }">
      <div class="html-content">
        <div v-html="data.text" />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
